"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactStyleClasses = _interopRequireDefault(require("react-style-classes"));
var _ItemModule = _interopRequireDefault(require("./Item.module.css"));
var _excluded = ["children", "onClick", "isActive", "className", "isDisabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Item = function Item(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    isActive = _ref.isActive,
    className = _ref.className,
    isDisabled = _ref.isDisabled,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("li", _extends({
    className: (0, _reactStyleClasses.default)(_ItemModule.default.item, isActive && _ItemModule.default.active, className, isDisabled && _ItemModule.default.disabled),
    onClick: isDisabled ? function () {
      return null;
    } : onClick,
    tabIndex: 0
  }, props), children);
};
Item.propTypes = {
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  isActive: _propTypes.default.bool,
  className: _propTypes.default.string,
  isDisabled: _propTypes.default.bool
};
Item.defaultProps = {
  children: null,
  onClick: function onClick() {
    return null;
  },
  isActive: false,
  className: null,
  isDisabled: false
};
var _default = Item;
exports.default = _default;